let lenisInstance = null;
const listeners = new Set();

export const setLenisInstance = (lenis) => {
  lenisInstance = lenis;
  listeners.forEach((cb) => cb(lenisInstance));
};

export const getLenisInstance = () => lenisInstance;

// Notifies cb immediately if the instance already exists, and again
// whenever it changes. Returns an unsubscribe function.
export const onLenisInstanceChange = (cb) => {
  listeners.add(cb);
  cb(lenisInstance);
  return () => listeners.delete(cb);
};
